import React, { ButtonHTMLAttributes } from 'react';
import styled from '@xstyled/styled-components';
import Icon from '~/assets/icons/help-btn.svg';
import { t } from 'ttag';
import { jumpAnimation } from '~/ui/animation';

const StyledIcon = styled(Icon)`
  width: 13px;
  height: 27.5px;
  margin-top: 10px;
`;

const Button = styled.button`
  background: ${p => p.theme.colors.overlayMed};
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  border: none;
  color: ${p => p.theme.colors.white};
  font-family: ${p => p.theme.fonts.title};
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover > svg {
    animation: ${jumpAnimation('10px', '5px', '10px')} 0.7s linear infinite;
  }
  padding: 0px;
  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 25px;
    height: 25px;
  }
`;

export const HelpButton = React.forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(
  (
    {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      children,
      ...props
    },
    ref
  ) => (
    <Button {...props} ref={ref} aria-label={t`Help`} aria-haspopup="dialog">
      <StyledIcon aria-hidden="true" focusable="false" />
    </Button>
  )
);

HelpButton.displayName = 'HelpButton';
